import React, { Suspense, lazy, useEffect, useState } from "react";
import "react-phone-input-2/lib/style.css";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { Get } from "./AxiosFunction/AxiosFunction.js";
import Loader from "./Components/Loader";
import { BaseUrl } from "./Config/apiUrl.js";
import BeforeLoginRoute from "./HelperFunction/BeforeLoginRoute.js";
import ProtectedRoute from "./HelperFunction/ProtectedRoute.js";
import "./assets/table.css";
import { updateUser } from "./redux/authSlice.js";
import { getAllFieldsData } from "./redux/commonSlice.js";

const Login = lazy(() => import("./Pages/Login/Login.jsx"));
const Home = lazy(() => import("./Pages/Home"));
const AddEditDrivers = lazy(() => import("./Pages/AddEditDrivers"));
const Drivers = lazy(() => import("./Pages/Drivers"));
const Hubs = lazy(() => import("./Pages/Hubs"));
const AddEditHubs = lazy(() => import("./Pages/AddEditHubs"));
const Lines = lazy(() => import("./Pages/Lines"));
const AddEditLines = lazy(() => import("./Pages/AddEditLines"));
const Alerts = lazy(() => import("./Pages/Alerts"));
const AddEditAlerts = lazy(() => import("./Pages/AddEditAlerts"));
const Setting = lazy(() => import("./Pages/Setting"));

const App = () => {
  const { token, isLogin } = useSelector((state) => state?.authReducer);
  const [isLoading, setIsLoading] = useState(true); // Set initial loading state to true
  const dispatch = useDispatch();
  const getUserData = async () => {
    const apiUrl = BaseUrl("auth/profile");
    const response = await Get(apiUrl, token, dispatch);
    if (response !== undefined) {
      dispatch(updateUser(response?.data?.data));
    }
  };

  const getAllHubs = async () => {
    const url = BaseUrl("hub/all");
    const response = await Get(url, token, dispatch);
    if (response !== undefined) {
      dispatch(getAllFieldsData(response?.data?.data));
    }
  };

  useEffect(() => {
    if (isLogin) {
      getUserData();
      getAllHubs();
    }
    setIsLoading(false); // Set loading state to false after data fetching completes
  }, [isLogin]);

  return (
    <>
      <BrowserRouter>
        <ToastContainer />
        {isLoading ? ( // Conditional rendering of loader
          <Loader />
        ) : (
          <Suspense fallback={<Loader />}>
            <Routes>
              <Route
                path="/login"
                element={<BeforeLoginRoute file={<Login />} />}
              />
              <Route path="/" element={<ProtectedRoute file={<Home />} />} />
              <Route
                path="/drivers"
                element={<ProtectedRoute file={<Drivers />} />}
              />
              <Route
                path="/add-edit-drivers"
                element={<ProtectedRoute file={<AddEditDrivers />} />}
              />
              <Route path="/hub" element={<ProtectedRoute file={<Hubs />} />} />
              <Route
                path="/add-edit-hubs"
                element={<ProtectedRoute file={<AddEditHubs />} />}
              />
              <Route
                path="/lines"
                element={<ProtectedRoute file={<Lines />} />}
              />

              <Route
                path="/add-edit-lines"
                element={<ProtectedRoute file={<AddEditLines />} />}
              />
              <Route
                path="/alerts"
                element={<ProtectedRoute file={<Alerts />} />}
              />
              <Route
                path="/add-edit-alerts"
                element={<ProtectedRoute file={<AddEditAlerts />} />}
              />
              <Route
                path="/setting"
                element={<ProtectedRoute file={<Setting />} />}
              />

              <Route path="*" exact element={<Login />} />
            </Routes>
          </Suspense>
        )}
      </BrowserRouter>
    </>
  );
};

export default App;
